var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"all"},[_c('div',{staticClass:"center"},[_c('div',{staticClass:"title"},[_vm._v("SCORE")]),_c('div',{staticClass:"num"},[_vm._v(_vm._s(_vm.score))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }